export default "__VITE_ASSET__CnA9Z7Ks__"